module.exports = __webpack_public_path__ + "static/media/quick@3x.b966e635.png";